export const blockVideoFields = ``;